<template>
  <div class="mt-20">
    <h5 class="text-bold">Adjust KFB Configuration</h5>
    <div class="row">

      <div id="fabric-id-input" class="col-md-12 mt-20">
        <label>Fabric</label>
        <v-select
          class="select-fabric"
          :options="fabrics"
          v-model="productOrder.configuration.fabric_id"
          label="production_name"
          :reduce="(fabrics) => fabrics.id"
          placeholder="Select Fabric" />

        <small v-if="errors.fabric_id" class="text-danger">Required Fabric</small>

      </div>

      <div id="cuff-type-id-input" class="col-md-12 mt-20">
        <label>Size</label>
        <v-select
          class="select-size"
          :options="sizes"
          v-model="productOrder.configuration.size"
          placeholder="Select Size"
        />
        <small v-if="errors.size" class="text-danger"
          >Required Size</small
        >
      </div>

      <div v-if="productOrder.product_type == 'PCP'" id="cuff-type-id-input" class="col-md-12 mt-20">
        <label>Cuff Type</label>
        <v-select
          class="select-cuff-type"
          :options="cuffTypes"
          v-model="productOrder.configuration.cuff_type"
          placeholder="Select Cuff Type"
        />
        <small v-if="errors.cuff_type" class="text-danger"
          >Required Cuff Type</small
        >
      </div>

      <div class="col-md-12 mt-20">
        <button class="btn btn-primary btn-block" @click="updateKellerfaltenbluse">
          Update Kellerfaltenbluse
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["productOrder"],

  data() {
    return {
      fabrics: [],
      sizes: [],
      cuffTypes: [],
      errors: {},
    };
  },

  mounted() {
    this.getFabrics();
    this.sizes = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
    this.cuffTypes = ['1', '2'];
  },

  methods: {
    async getFabrics() {
      let res = await axios.get("/v2/fabrics?as_dropdown=1");
      this.fabrics = res.data.data.collection;
    },

    async updateKellerfaltenbluse() {
      try {
          this.errors = {};
          let res = await axios.post(`product_orders/update-order-configuration/${this.productOrder.id}`, this.productOrder.configuration);
          if (res) {
            toastr.success("Successfully Updated");
          }
      } catch (error) {
        this.errors = error.response.data.errors;
      }
    },

  },
};
</script>
